export default __webpack_public_path__ + "static/media/element_81.edbc731f.webp";